import React from 'react'
import './notFound.css'

const NotFound = () => {
  return (
    <section className='notfound'>
      <div className='container notfound__container'>
        <div className='notfound__layoutcontainer'>
          <h1>404</h1>
          <h4>This Page Could Not Be Found</h4>
        </div>
      </div>
    </section>
  )
}

export default NotFound